import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["ariaLabel", "placeholder", "value", "name", "disabled", "onBlur", "onFocus", "onChange", "onKeyDown", "autoComplete", "autoFocus", "inputRef", "leftIcon", "className", "onClear", "onCancel", "showCancelButton", "showClearButton", "type", "size", "invert"];
import React, { forwardRef, useRef, useState } from 'react';
import { cnBem } from '@carnica/utils';
import { IconCloseRoundStroked, IconSearchOutline } from '@carnica/graphics';
import { useComponentSize } from '@carnica/utils/hooks';
import { withDataConverter } from '@beef/react';
import { Button } from "../Button";
import styles from "./styles.pcss";
import { dataConverter } from "./utils";
export var cnSearchField = cnBem('search-field', styles);
var SearchFieldRender = /*#__PURE__*/forwardRef(function (props, ref) {
  var ariaLabel = props.ariaLabel,
    placeholder = props.placeholder,
    _props$value = props.value,
    value = _props$value === void 0 ? '' : _props$value,
    name = props.name,
    disabled = props.disabled,
    onBlur = props.onBlur,
    onFocus = props.onFocus,
    onChangeProp = props.onChange,
    onKeyDownProp = props.onKeyDown,
    _props$autoComplete = props.autoComplete,
    autoComplete = _props$autoComplete === void 0 ? 'off' : _props$autoComplete,
    _props$autoFocus = props.autoFocus,
    autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
    inputRef = props.inputRef,
    _props$leftIcon = props.leftIcon,
    Icon = _props$leftIcon === void 0 ? IconSearchOutline : _props$leftIcon,
    className = props.className,
    onClear = props.onClear,
    onCancel = props.onCancel,
    showCancelButton = props.showCancelButton,
    showClearButton = props.showClearButton,
    _props$type = props.type,
    type = _props$type === void 0 ? 'search' : _props$type,
    _props$size = props.size,
    size = _props$size === void 0 ? 's' : _props$size,
    invert = props.invert,
    otherProps = _objectWithoutProperties(props, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFocused = _useState2[0],
    setIsFocused = _useState2[1];
  var cancelButtonRef = useRef(null);
  var cancelButtonWidth = useComponentSize(cancelButtonRef).width;
  var handleFocusAction = function handleFocusAction(action) {
    return function (e) {
      var _ref;
      (_ref = action === 'focus' ? onFocus : onBlur) === null || _ref === void 0 ? void 0 : _ref(value, e);
      setIsFocused(action === 'focus');
    };
  };
  var onChange = function onChange(e) {
    return onChangeProp === null || onChangeProp === void 0 ? void 0 : onChangeProp(e.target.value, e);
  };
  var onKeyDown = function onKeyDown(e) {
    return onKeyDownProp === null || onKeyDownProp === void 0 ? void 0 : onKeyDownProp(e);
  };
  var isCancelButtonVisible = showCancelButton && (isFocused || !!value.length);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cnSearchField(null, [className]),
    ref: ref
  }, otherProps), /*#__PURE__*/React.createElement("div", {
    className: cnSearchField('wrapper', {
      collapsed: isCancelButtonVisible,
      size: size,
      invert: invert
    }),
    style: _defineProperty({}, '--search-field-cancel-width', "".concat(cancelButtonWidth, "px"))
  }, /*#__PURE__*/React.createElement(Icon, {
    className: cnSearchField('icon'),
    color: invert ? 'tertiary-invert' : 'tertiary',
    size: size
  }), /*#__PURE__*/React.createElement("input", {
    "aria-label": ariaLabel || placeholder,
    autoComplete: autoComplete
    /* eslint-disable-next-line jsx-a11y/no-autofocus */,
    autoFocus: autoFocus,
    className: cnSearchField('input', {
      size: size
    }),
    disabled: disabled,
    name: "search-".concat(name || 'field'),
    onBlur: handleFocusAction('blur'),
    onChange: onChange,
    onFocus: handleFocusAction('focus'),
    onKeyDown: onKeyDown,
    placeholder: placeholder,
    ref: inputRef,
    type: type,
    value: value
  }), showClearButton && /*#__PURE__*/React.createElement(IconCloseRoundStroked, {
    className: cnSearchField('close'),
    color: invert ? 'tertiary-invert' : 'tertiary',
    onClick: function onClick(e) {
      return onClear === null || onClear === void 0 ? void 0 : onClear('', e);
    },
    size: size,
    tagName: "button",
    type: "button"
  })), onCancel && /*#__PURE__*/React.createElement(Button, {
    "aria-hidden": !isCancelButtonVisible,
    "aria-label": "\u043E\u0442\u043C\u0435\u043D\u0438\u0442\u044C \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435",
    className: cnSearchField('button', {
      visible: isCancelButtonVisible,
      invert: invert
    }),
    disabled: !isCancelButtonVisible,
    mode: "inline",
    onClick: onCancel,
    ref: cancelButtonRef
  }, "\u043E\u0442\u043C\u0435\u043D\u0430"));
});
export var SearchField = withDataConverter(dataConverter)(SearchFieldRender);